import React from 'react';
import styled from 'styled-components';

import useUI from 'src/hooks/use-ui';

import { ProductRecommendationSource } from 'src/utils/analytics/trackers/internal-gtm-tracker/internal-gtm-tracker.types';
import { ProductCarousel as ProductCarouselV2 } from 'src/components/carousel-v2/types/product-carousel';
import { useSponsoredProductHandlers } from 'src/utils/ads/hooks/sponsored-products';
import { useCartRecommendationsCarousel } from './use-cart-recommendations-carousel';

type CartRecommendationsCarouselProps = {
  mt?: string;
  alwaysUseSmallCards?: boolean;
};

export function CartRecommendationsCarousel({
  mt,
  alwaysUseSmallCards = false,
}: CartRecommendationsCarouselProps): JSX.Element {
  const { closeCartDrawer } = useUI();
  const carouselProps = useCartRecommendationsCarousel();
  const { products, loading, placement } = carouselProps;
  const title = 'Before You Go';

  const { handleSponsoredProductClick, handleSponsoredProductImpression } = useSponsoredProductHandlers({
    trackerSource: ProductRecommendationSource.moloco,
    adPlacement: 'cart.carousel',
  });

  const handleProductClick = (product, index): void => {
    handleSponsoredProductClick(product, index);
    closeCartDrawer();
  };

  return (
    <Wrapper>
      <ProductCarouselV2
        title={title}
        products={products}
        isLoading={loading}
        source={ProductRecommendationSource.crossingMinds}
        isSmallTitle
        mt={mt}
        gradientColor='var(--dcm-cart-bg)'
        onProductClick={handleProductClick}
        onProductView={handleSponsoredProductImpression}
        onQuickAddToCart={handleSponsoredProductClick}
        alwaysUseSmallCards={alwaysUseSmallCards}
        placement={placement}
      />
    </Wrapper>
  );
}

const Wrapper = styled.div`
  padding: 0 20px;
`;
